<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('Mall') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div>Order</div>
  </div>
</template>
<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
export default {
  computed: {
    locale() {
      return this.$store.state.locale;
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
  },
};
</script>
